import { type RouteRecordRaw } from 'vue-router'

export const privateSectionsRouter: RouteRecordRaw[] = [
  {
    path: '/privateSections',
    component: async () => import('./PrivateSections.vue'),
  },
]
